import classNames from 'classnames'
import styles from './SectionContainer.module.css'
import { SectionContainerProps } from './SectionContainer.types'

export const SectionContainer = ({
  tag = 'section',
  width = 'full',
  children,
  wrapperId,
  wrapperClassName,
  wrapperRef,
  wrapperStyle,
  innerClassName,
}: SectionContainerProps) => {
  const Wrapper = tag || 'section'

  return (
    <Wrapper
      id={wrapperId}
      ref={wrapperRef}
      style={wrapperStyle}
      className={classNames(
        {
          [styles.full]: width === 'full',
          [styles.wide]: width === 'wide',
          [styles.medium]: width === 'medium',
          [styles.narrow]: width === 'narrow',
          [styles.superNarrow]: width === 'super-narrow',
        },
        wrapperClassName || ''
      )}>
      <div
        className={classNames(
          {
            [styles.wideInner]: width === 'wide',
            [styles.mediumInner]: width === 'medium',
            [styles.narrowInner]: width === 'narrow',
            [styles.superNarrowInner]: width === 'super-narrow',
          },
          innerClassName
        )}>
        {children}
      </div>
    </Wrapper>
  )
}
